$(function () {

    $.widget("movimax.schedulePage", {
        options: {
            date: new Date()
        },
        _create: function () {
            var opt = this.options;
            var $elm = this.element;
            var date = new Date();

            // FUNGSI UNTUK AMBIL DATA DARI DATABASE
            var generateSchedule = function (location, date) {
                if (!date) return false;
                var path = "/showtime/showschedule";
                encRequest(path, { location: location, date: date }, function (reply) {
                    var r = reply[location] ? reply[location] : [];
                    var locationUpper = location.toUpperCase();
                    $elm.find(".content").html("");
                    if (!reply[location]) {
                        var $content = $("<div>").addClass("content").appendTo($elm);
                        var $blank = $("<div>").addClass("description").appendTo($content);
                        var $blankContent = $("<div>Maaf Jadwal Untuk Saat Ini Masih Kosong, Anda Dapat Memeriksa Jadwal Lainnya di Atas.</div>").addClass("content").appendTo($blank);
                        $blankContent.addClass("text-center bordered-container");
                    }
                    r.forEach(function (data) {
                        var showTimes = data.show_time;
                        var htm = accounting.formatMoney(data.htm, "Rp ", 0, ".", ",");
                        var title = data.title;
                        var studio = data.studio;
                        var label = data.label;
                        var cover = data.movie ? data.movie.cover : "http://via.placeholder.com/130x180";
                        var movie = data.movie;
                        var locationId = data.location_id ? data.location_id : null;
                        var location = locationUpper;
                        var dt = moment(date).format("dddd, DD MMM YYYY");
                        generateContent(showTimes, title, studio, cover, movie, location, dt, htm, label, locationId);
                    });
                })
            };

            // UNTUK MEMBERSIHKAN DAN MEMBANGUN SELECTOR DATE DAN LOCATION
            var generateSelector = function () {
                $elm.find(".select-schedule-container").html("");
                // Selector
                var $row = $("<div>").addClass("row select-schedule-container").appendTo($elm);
                var $locationContainer = $("<div>").addClass("col-lg-6").appendTo($row);
                var $dateContainer = $("<div>").addClass("col-lg-6").appendTo($row);
                var $selectLocationContainer = $("<div>").addClass("form-group select-schedule-container").appendTo($locationContainer);
                var $selectDateContainer = $("<div>").addClass("form-group select-schedule-container").appendTo($dateContainer);
                var $labelLocation = $("<label> LOKASI </label>").addClass("select-schedule").appendTo($selectLocationContainer);
                var $labelDate = $("<label> TANGGAL </label>").addClass("select-schedule").appendTo($selectDateContainer);
                var $locationSelector = $("<select class='select-theme form-control'>").attr("id", "locationSelector").appendTo($selectLocationContainer);
                var $dateSelector = $("<select class='select-theme form-control'>").attr("id", "dateSelector").appendTo($selectDateContainer);
                encRequest('/locations/getall', function (reply) {
                    reply.forEach(function (location) {
                        $("<option>")
                            .val(location.id)
                            .text(location.name)
                            .appendTo($locationSelector);
                    });
                    encRequest('/showtime/getavailabledates', function (reply) {
                        reply.forEach(function (date) {
                            var id = date;
                            var d = moment(date).format("dddd, DD MMM YYYY");
                            $("<option>").val(id).text(d).appendTo($dateSelector);
                        });

                        var location = $("#locationSelector").val();
                        var date = $("#dateSelector").val();
                        generateSchedule(location, date);

                        // register event
                        $("#locationSelector").unbind().change(function () {
                            var location = $("#locationSelector").val();
                            var date = $("#dateSelector").val();
                            generateSchedule(location, date);
                        });

                        $("#dateSelector").unbind().change(function () {
                            var location = $("#locationSelector").val();
                            var date = $("#dateSelector").val();
                            generateSchedule(location, date);
                        });
                    });
                });
            };


            var generateContent = function (showTimes, title, studio, cover, movie, location, date, htm, label, locationId) {

                var studioLink = locationId ? "/studio?location=" + locationId + "&studio=" + studio : "#";
                var $content = $("<div>").addClass("content").appendTo($elm);
                var $row1 = $("<div>").addClass("row").appendTo($content);
                var $collg12 = $("<div>").addClass("col-lg-12").appendTo($row1);
                var $contentScheduleContainer = $("<div>").addClass("content-schedule-container mt-2").appendTo($collg12);
                var $row3 = $("<div>").addClass("row").appendTo($contentScheduleContainer);
                var $colmd2 = $("<div>").addClass("col-md-2").appendTo($row3);
                var $imgContainer = $("<div>").addClass("img-container").appendTo($colmd2);
                var $img = $("<img>").attr("src", cover).appendTo($imgContainer);
                var $imgCover = $("<div>").addClass("img-cover").appendTo($imgContainer);
                var $imgButton = $("<a>").attr("href", "/article/" + movie.code).addClass("img-button").appendTo($imgCover);
                var $colmd10 = $("<div style='padding-left: 0;'>").addClass("col-md-10").appendTo($row3);
                var $contentContainer = $("<div>").addClass("content-container").appendTo($colmd10);
                var $title = $("<div>" + title + "</div>").addClass("title").appendTo($contentContainer);
                var $infoContainer = $("<div>").addClass("info-container").appendTo($contentContainer);
                var $htm = $("<div> HTM: " + htm + "</div>").addClass("htm").appendTo($infoContainer);
                var $studioContainer = $("<a></a>").attr("href", studioLink).addClass("studio-container").appendTo($infoContainer);
                var $label = $("<div> STUDIO </div>").addClass("label-studio").appendTo($studioContainer);
                var $number = $("<div>" + studio + "</div>").addClass("number").appendTo($studioContainer);
                var $type = $("<div> " + label + " </div>").addClass("type").appendTo($studioContainer);
                var $date = $("<div>" + date + "</div>").addClass("date").appendTo($infoContainer);
                var $rating = $("<span>" + movie.genre.text + "</span>").addClass("info font-size-15").appendTo($infoContainer);
                var $delimiter = $("<span> | </span>").addClass("info font-size-15").appendTo($infoContainer);
                var $duration = $("<span>" + movie.duration + " MENIT </span>").addClass("font-size-15").appendTo($infoContainer);
                var $location = $("<div> MOVIMAX " + location + "</div>").addClass("location font-size-15").appendTo($infoContainer);
                var $footerContainer = $("<div>").addClass("footer-container").appendTo($infoContainer);
                var $btnGroup = $("<div>").addClass("btn-group margin-top-5").appendTo($footerContainer);

                for (var j = 0; j < showTimes.length; j++) {
                    $("<a>" + showTimes[j].hours + "</a>").attr("href", "/user#!/user/seats/" + showTimes[j].id).addClass("btn btn-info btn-schedule").appendTo($btnGroup);
                }
            };





            // KETIKA KONDISI AWAL LOAD
            generateSelector();

        }
    });

});
